import { render, staticRenderFns } from "./singinheader.vue?vue&type=template&id=d1cb6a7c&scoped=true&"
import script from "./singinheader.vue?vue&type=script&lang=js&"
export * from "./singinheader.vue?vue&type=script&lang=js&"
import style0 from "./singinheader.vue?vue&type=style&index=0&id=d1cb6a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cb6a7c",
  null
  
)

export default component.exports